<script lang="ts" setup>
  import { useHttpClient, useRoute } from '@othercommerce/foundation';
  import { loginEvent, useGoogleTagManager } from '@storefront/storefront';

  const route = useRoute();
  const http = useHttpClient();
  const gtm = useGoogleTagManager();

  function onSubmit(data: any) {
    return http.post(route('web.account.session.store', data)).then(() => gtm.push(loginEvent()));
  }
</script>
<template>
  <FormController v-slot="{ processing }" class="sign-in-form" @submit="onSubmit">
    <div class="sign-in-form__inputs">
      <SfFormInput id="sign-in-email" :label="$t('SHOP.AUTH.LABEL.EMAIL')" autocomplete="email" name="email" type="email" />
      <div class="sign-in-form__password">
        <SfFormInput id="sign-in-password" :label="$t('SHOP.AUTH.LABEL.PASSWORD')" autocomplete="current-password" name="password" type="password" />
        <RouterLink :href="$route('web.account.password.forgotten.create')" class="sign-in-form__forget-password">
          {{ $t('SHOP.AUTH.ACTION.FORGOTTEN_PASSWORD') }}
        </RouterLink>
      </div>
    </div>
    <SfFormSwitch :label="$t('SHOP.AUTH.LABEL.REMEMBER_ME')" name="remember" />
    <SfButton :loading="processing" primary type="submit">
      {{ $t('SHOP.AUTH.ACTION.SIGN_IN') }}
    </SfButton>
  </FormController>
</template>

<style lang="scss">
  :root {
    --sf-sign-in-form-forget-font-size: 0.75rem;
    --sf-sign-in-form-forget-font-weight: var(--font-weight-semi);
    --sf-sign-in-form-forget-margin-top: 0.375rem;
    --sf-sign-in-form-forget-margin-right: var(--sf-input-padding-right, 0)
  }

  .sign-in-form {
    &__password,
    &__inputs {
      display: flex;
      flex-direction: column;
    }

    &__password {
      align-items: flex-end;
    }

    &__inputs {
      gap: var(--form-gap-y) var(--form-gap-x);
    }

    &__forget-password {
      font-size: var(--sf-sign-in-form-forget-font-size);
      font-weight: var(--sf-sign-in-form-forget-font-weight);
      margin-top: var(--sf-sign-in-form-forget-margin-top);
      margin-right: var(--sf-sign-in-form-forget-margin-right);
    }
  }
</style>
